<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 207.544"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="58.383"
            cy="110.497"
            r="9.984"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M59.524 146.354c-0.009,10.138 -0.037,19.583 -0.083,28.334 -0.054,10.429 -0.134,19.874 -0.24,28.333 -3.718,0.157 -7.506,0.071 -10.998,0.455 -1.693,-0.01 -3.403,0.065 -5.096,0.142 0,0 0.066,-9.594 0.195,-28.781 0.05,-7.356 0.109,-16.124 0.178,-26.302 5.164,0.018 10.512,-0.709 16.044,-2.181z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M59.441 174.688c0.046,-8.751 0.074,-18.196 0.083,-28.334 5.035,-1.339 10.223,-3.295 15.563,-5.867 3.012,6.931 4.844,15.089 4.989,23.371 0.312,2.845 0.522,5.482 0.635,7.927 -7.72,2.293 -14.811,3.26 -21.27,2.903z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M59.441 174.688c6.459,0.357 13.55,-0.61 21.27,-2.903 1.296,27.824 -9.753,30.74 -21.51,31.236 0.106,-8.459 0.186,-17.904 0.24,-28.333z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M43.302 174.837c-0.129,19.187 -0.195,28.781 -0.195,28.781 -12.149,0.551 -23.452,1.18 -21.752,-28.929 6.806,0.983 14.122,1.032 21.947,0.148z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M43.302 174.837c-7.825,0.884 -15.141,0.835 -21.947,-0.148 0.268,-4.747 0.859,-10.258 1.822,-16.655 0.677,-4.5 1.722,-8.71 3.086,-12.559 5.492,2.02 11.23,3.04 17.217,3.06 -0.069,10.178 -0.128,18.946 -0.178,26.302z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M43.48 148.535c-5.987,-0.02 -11.725,-1.04 -17.217,-3.06 5.197,-14.679 15.011,-24.103 26.611,-24.306 9.106,-0.159 17.258,7.919 22.213,19.318 -5.34,2.572 -10.528,4.528 -15.563,5.867 -5.532,1.472 -10.88,2.199 -16.044,2.181z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M23.177 158.034c3.259,-21.662 15.055,-36.609 29.697,-36.865 14.642,-0.256 26.817,20.786 27.202,42.689 4.992,45.457 -16.371,37.915 -31.873,39.618 -15.758,-0.09 -32.942,7.176 -25.026,-45.442zm6.434 -20.295c-0.204,-30.416 5.849,-64.201 18.064,-97.602 8.5,-29.773 16.99,-32.631 17.536,-7.041 0.352,30.759 1.344,66.039 8.537,104.365"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="66.55"
            cy="13.735"
            r="9.984"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]

}
</script>
